export default __webpack_public_path__ + "static/media/down-black.2022ae98.svg";